import HTASvgClover from '@img/icons/clover-green.svg?url';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import * as React from 'react';
import { useCookies } from 'react-cookie';
import S from './NotificationBanner.styles';
const NotificationBanner = ({ id, icon = HTASvgClover, notification, }) => {
    const [cookies, setCookie] = useCookies();
    if (!notification) {
        return null;
    }
    const { text, cta } = notification;
    return (React.createElement(S.Container, { "data-cookie": cookies[`cookieNotificationSet-${id}`] ? true : false },
        React.createElement(S.NotificationBar, null,
            React.createElement(S.NotificationInner, null,
                React.createElement(S.NotificationGrid, null,
                    React.createElement(S.NotificationTextArea, null,
                        React.createElement(S.NotificationIcon, null,
                            ' ',
                            React.createElement(S.Clover, { src: icon, role: "presentation" })),
                        React.createElement(S.NotificationText, null,
                            React.createElement("span", null, text)),
                        cta?.text && cta?.url && (React.createElement(LinkButton, { type: "button", themeOption: notification.ctaTheme, title: cta.text, href: cta.url, target: cta.target }))),
                    React.createElement(S.NotificationCtaArea, null,
                        React.createElement(S.NotificationClose, { type: "button", onClick: () => setCookie(`cookieNotificationSet-${id}`, true, { path: '/' }) },
                            React.createElement(S.Close, null))))))));
};
export default NotificationBanner;
